import React from 'react';
import { Checkbox } from '@azgaz/azgaz-ui';
import { uniq, isArray } from 'lodash';
import cn from 'classnames';

import style from './style.module.scss';

type CheckboxItem<Value> = {
  title: string;
  value: Value;
};

type CheckboxListProps<Value = any> = {
  title: string;
  onChange: (v: string[]) => void;
  items: CheckboxItem<Value>[];
  // eslint-disable-next-line react/require-default-props
  value?: Value[] | Value;
};

const CheckboxList = ({
  title,
  items,
  onChange,
  value = [],
}: CheckboxListProps) => {
  const resolvedValue = isArray(value) ? value : [value];

  return (
    <div className="aui-Field">
      <div className="aui-Field-title aui-Field-title-upper">{title}</div>
      <div className={cn('aui-Field-field', style.field)}>
        {items.map(item => (
          <Checkbox
            key={item.value}
            value={!!resolvedValue.find(v => v === item.value)}
            onChange={(e: any) => {
              const { checked } = e.target;
              if (checked) {
                onChange(uniq([...resolvedValue, item.value]));
              } else {
                onChange(resolvedValue.filter(v => v !== item.value));
              }
            }}
            className={style.checkbox}
          >
            {item.title}
          </Checkbox>
        ))}
      </div>
    </div>
  );
};

export default CheckboxList;
